import React from "react";
import settingable from "fantastic/components/hoc/settingable";
import SingleStringSetting from "fantastic/components/common/controls/SingleStringSetting";
import BackgroundSettings from "fantastic/components/common/controls/background/Settings";

const UnsubscribleSettings = ({ selected, update, selectedNode }) => {
  const onChange = (field, value) => {
    const newValue = value === 'transparent' ? '' : value;
    update(selected, { [field]: newValue });
  }

  const isChange = (field) => {
    return (value) => {
      update(selected, { [field]: value });
    }
  };

  const linkColor = {
    onChange,
    label: i18n.t('link_color'),
    onlyColor: true,
    scrollToIfNeeded: () => {},
    color: { field: "css_link_color", value: selectedNode.css_link_color }
  }

  return (
    <>
      <SingleStringSetting value={selectedNode.contents} onChange={isChange('contents')} label={i18n.t('text')}/>
      <SingleStringSetting value={selectedNode.label} onChange={isChange('label')} label={i18n.t('link_text')}/>
      <BackgroundSettings {...linkColor} />
    </>
  )
}

export default settingable("font", "text-align", "background", "padding")(UnsubscribleSettings);
